<script setup>
import { __ } from '@/utils';
import { inject, ref } from 'vue';
import Hint from '@components/hint.vue';
import IconPhones from '@components/icons/icon-phones.vue';

const props = defineProps(['phone']);
const { setStep, response } = inject('form');

const days = [
    __('Sunday'),
    __('Monday'),
    __('Tuesday'),
    __('Wednesday'),
    __('Thursday'),
    __('Friday'),
    __('Saturday'),
];

const portingTime = response.value?.subscribers?.[0]?.porting_time;

const handleDate = (minutes = false) => {
    const date = new Date(portingTime);
    if(minutes) {
        date.setMinutes(date.getMinutes() + minutes);
    }
    const day = days[date.getDay()];
    const time = date.getHours() + ":" + ("0" + date.getMinutes()).slice(-2);

    return {
        day,
        time
    }
}

const currentDate = handleDate();
const dateAfter15Minutes = handleDate(15);

const simAndroid = ref(simPdfGuilds.sim_android);
const simIOS = ref(simPdfGuilds.sim_ios);
const htmlText = ref(simPdfGuilds.sim_porting_text)
const htmlTopText = ref(simPdfGuilds.sim_porting_line_top)
</script>
<template>
    <div class="congrats">
        <div class="congrats__inner">
            <img :src="`${theme_path.url}/resources/images/svg/icon-sim-fly.svg`" alt="">
            <div class="congrats__heading">
                <h3 class="gradient">{{ __('The SIM card has been successfully activated and the roaming process has begun!') }}</h3>
            </div>

            <div class="congrats__order-number">
                <p>
                    {{ __('line number') }} {{ props.phone }}
                </p>
            </div>
            <h4>{{ __('So what happens now?') }}</h4>
            <div class="sim-steps">
                <div class="sim-step">
                    <div class="sim-step__arrow">
                        <span></span>
                    </div>
                    <h3 class="gradient">01</h3>
                    <div class="sim-step__image">
                        <img :src="`${theme_path.url}/resources/images/svg/icon-smarthphone.svg`" />
                    </div>
                    <h5>
                        {{ __('The mobility process will begin on the day') }} {{ currentDate.day }}<br />
                        {{ __('at') }} {{ currentDate.time }}
                    </h5>

                </div>
                <div class="sim-step">
                    <div class="sim-step__arrow">
                        <span></span>
                    </div>
                    <h3 class="gradient">02</h3>
                    <div class="sim-step__image">
                        <IconPhones />
                    </div>
                    <h5>
                        {{ __('The mobility process is about to end') }}<br />
                        {{ __('on') }} {{ dateAfter15Minutes.day }} {{ __('at') }} {{ dateAfter15Minutes.time }}
                    </h5>
                </div>
                <div class="sim-step">
                    <h3 class="gradient">03</h3>
                    <div class="sim-step__image">
                        <img :src="`${theme_path.url}/resources/images/svg/icon-sim-step.svg`" />
                    </div>
                        <span dir="rtl" v-html="htmlTopText"></span>
                </div>
            </div>
           
            <h5 class="fz18"><strong>{{ __('Still struggling? Use our guides') }}</strong></h5>

            <div class="guide-cta mb13">
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="simAndroid" target="_blank" v-if="simAndroid">
                        {{ __('Android Guide') }}
                    </a>
                </div>
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="simIOS" target="_blank" v-if="simIOS">
                        {{ __('IOS Guide') }}
                    </a>
                </div>
            </div>
            <span dir="rtl" v-html="htmlText"></span>
            <div class="success-cta-row">
                <a href="/activation" class="link-arrow link-arrow--dark" @click.prevent="setStep('initial')">
                    {{ __('Click to activate another SIM') }}
                </a><!-- /.btn -->
                <a href="/" class="btn btn--arrows w156">{{ __('Back to Home page') }}</a>
            </div>
        </div>
    </div>
</template>